<template>
    <div>
        <v-text-field v-if="isSportkapitaen" v-model="dataObject.team"
                      label="Zuständig für Liga/Mannschaft" hide-details>
        </v-text-field>
        <v-text-field v-model="dataObject.name"
                      label="Name" hide-details>
        </v-text-field>
        <v-text-field v-model="dataObject.strasse"
                      label="Straße" hide-details>
        </v-text-field>
        <v-text-field v-model="dataObject.wohnort"
                      label="Wohnort" hide-details>
        </v-text-field>
        <v-text-field v-model="dataObject.telefon"
                      label="Telefon" hide-details>
        </v-text-field>
        <v-text-field v-model="dataObject.handy"
                      label="Handy" hide-details>
        </v-text-field>
        <v-text-field v-model="dataObject.email"
                      label="e-Mail" hide-details>
        </v-text-field>
    </div>
</template>

<script>
    export default {
        name: "vereinsdatenblatt-edit-person",
        props: ['dataObject', 'rules', 'isSportkapitaen'],
    }
</script>

<style scoped>

</style>